import styled from "styled-components";
import {
  color,
  ColorProps,
  display,
  DisplayProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  variant,
} from "styled-system";
import typos from "../theme/typos";

type TypoVariants = keyof typeof typos;

interface TypoProps
  extends TypographyProps,
    ColorProps,
    SpaceProps,
    DisplayProps {
  variant?: TypoVariants;
}
const Typo = styled.p<TypoProps>`
  display: flex;
  margin: 0;
  ${variant({
    scale: "typos", // Variants are styled directly with the theme defined in theme/typos.ts
  })}
  ${typography}
  ${color}
  ${space}
  ${display}
`;

export default Typo;
